module.exports = __webpack_public_path__ + "static/media/alert_partner_silver_x2_new.5ac01ae8.png";